import { useOverlayContext } from 'seagull';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { useCancelTask } from '~/tasks-drawer/hooks/useCancelTask';
import { useTasksJobs } from '~/tasks-drawer/hooks/useTasksJobs';
import { useFeatureFlags } from '../useFeatureFlags';
export const retryPdfErrorToastId = (previousJobId)=>"retry-agreement-pdf-error-".concat(previousJobId);
function jobToTask(res, relationshipId) {
    return {
        jobId: res.jobId,
        kind: 'relationshipPdf',
        status: res.status,
        progress: res.progress,
        updatedAt: Date.now(),
        seen: false,
        agreementName: res.agreementName,
        relationshipId
    };
}
export function useDownloadAgreementPdf() {
    const pdfHost = useStore(selectors.pdfHost);
    const { browser: { openNewTab } } = useIoContext();
    const { api } = useStoreActions();
    const { addTask } = useTasksJobs();
    const { cancelTask } = useCancelTask();
    const { RELATIONSHIP_PDF_SCOUT } = useFeatureFlags();
    const { showErrorToast } = useOverlayContext();
    const { t: texts } = useLocaleKeys('tasksDrawer');
    return {
        downloadAgreementPdf (relationshipId, lang, overrides) {
            if (!RELATIONSHIP_PDF_SCOUT) {
                openNewTab("".concat(pdfHost, "/relationship-pdf/").concat(relationshipId));
                return;
            }
            api.pdf.generateRelationshipPdf(relationshipId, lang).then((res)=>{
                var _ref;
                addTask(jobToTask(res, relationshipId), {
                    kind: 'auto',
                    message: (_ref = overrides === null || overrides === void 0 ? void 0 : overrides.generating) !== null && _ref !== void 0 ? _ref : texts.generating.startedToast()
                }, {
                    ready: overrides === null || overrides === void 0 ? void 0 : overrides.ready,
                    failed: overrides === null || overrides === void 0 ? void 0 : overrides.failed
                });
            }).catch(()=>{
                showErrorToast(texts.relationshipPdf.startFailedToast(), 'download-agreement-pdf-error');
            });
        },
        retryAgreementPdf (relationshipId, param) {
            let { previousJobId, lang } = param;
            cancelTask(previousJobId);
            api.pdf.generateRelationshipPdf(relationshipId, lang).then((res)=>{
                addTask(jobToTask(res, relationshipId), {
                    kind: 'auto',
                    message: texts.generating.startedToast()
                });
            }).catch(()=>{
                showErrorToast(texts.relationshipPdf.retryFailedToast(), retryPdfErrorToastId(previousJobId));
            });
        }
    };
}
